module.exports = __webpack_public_path__ + "assets/images/EURUNFIT20.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/EURUNFIT20.png
// module id = 1374
// module chunks = 1